import AuthService from '../services/security/auth.service'

const user = JSON.parse(localStorage.getItem('auth_user'))
const initialState = user
  ? { status: { loggedIn: true }, user }
  : { status: { loggedIn: false }, user: null }

export const auth = {
  namespaced: true,
  state: initialState,
  actions: {
    login({ commit }, user) {
      return AuthService.login(user).then(
        user => {
          commit('loginSuccess', user)
          return Promise.resolve(user)
        },
        error => {
          commit('loginFailure')
          return Promise.reject(error)
        }
      )
    },
    logout({ commit }) {
      AuthService.logout()
      commit('logout')
    },
    forgotPassword({ commit }, user) {
      return AuthService.forgotPassword(user).then(
        user => {
          return Promise.resolve(user)
        },
        error => {
          return Promise.reject(error)
        }
      )
    },
    forgotPasswordProcess({ commit }, user) {
      return AuthService.forgotPasswordProcess(user).then(
        user => {
          return Promise.resolve(user)
        },
        error => {
          return Promise.reject(error)
        }
      )
    },
    signUp({ commit }, user) {
      return AuthService.signUp(user).then(
        user => {
          return Promise.resolve(user)
        },
        error => {
          return Promise.reject(error)
        }
      )
    },
    setRole({ commit }, data) {
      AuthService.setRole(data.provider, data.branch, data.employee)
    }
  },
  mutations: {
    loginSuccess(state, user) {
      state.status.loggedIn = true
      state.user = user
    },
    loginFailure(state) {
      state.status.loggedIn = false
      state.user = null
    },
    logout(state) {
      state.status.loggedIn = false
      state.user = null
    }
  }
}
